export default __webpack_public_path__ + "static/media/404.72d3ee3d.svg";